export default {"src":"/login-app/[GIT_HASH]/_next/static/media/file_yaml.498cc900.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};